import { appConfig } from "@/config";
import { webRoutes } from "@/config/web/routes";
import {
  ForgotPasswordForm,
  LoginForm,
  ResetPasswordForm,
  SelectOrganizationPage,
  VerifyEmailPage,
} from "@/core/auth/components";
import { Authenticated } from "@/core/auth/components/Authenticated/Authenticated";
import { Guest } from "@/core/auth/components/Guest/Guest";
import { RegisterForm } from "@/core/auth/components/RegisterForm/RegisterForm";
import { AccountPage, OrganizationSettingsPage } from "@/modules/account/components";
import { CapturePage } from "@/modules/capture/components/CapturePage";
import { LabelPage } from "@/modules/label/components/LabelPage";
import { AuthLayout } from "@/modules/layout";
import {
  ModelDetailPage,
  ModelIndexRedirect,
  ModelNewPage,
} from "@/modules/model/components";
import { ProjectIndexRedirect } from "@/modules/project/components/ProjectIndexRedirect";
import { ProjectsPage } from "@/modules/project";
import { RunPage } from "@/modules/run";
import { createBrowserRouter, RouteObject } from "react-router";

const { auth } = appConfig.web.routes;
const unguardedPublicRoutes: RouteObject = {
  element: <AuthLayout />,
  children: [
    { path: auth.resetPassword, element: <ResetPasswordForm /> },
    { path: auth.verifyEmail, element: <VerifyEmailPage /> },
    { path: auth.selectOrganization, element: <SelectOrganizationPage /> },
  ],
};
const guestRoutes: RouteObject = {
  element: <Guest />,
  children: [
    { path: auth.login, element: <LoginForm /> },
    { path: auth.register, element: <RegisterForm /> },
    { path: auth.forgotPassword, element: <ForgotPasswordForm /> },
  ],
};
const authenticatedRoutes: RouteObject = {
  element: <Authenticated />,
  children: [
    { path: webRoutes.main.projects, element: <ProjectsPage /> },
    { path: webRoutes.main.project, element: <ProjectIndexRedirect /> },
    { path: webRoutes.capture, element: <CapturePage /> },
    {
      path: webRoutes.model.modelList,
      element: <ModelIndexRedirect />,
    },
    {
      path: webRoutes.model.modelNew,
      element: <ModelNewPage />,
    },
    {
      path: webRoutes.model.modelDetail,
      element: <ModelDetailPage />,
    },
    { path: webRoutes.label, element: <LabelPage /> },
    { path: webRoutes.run, element: <RunPage /> },
    { path: webRoutes.account, element: <AccountPage /> },
    { path: webRoutes.main.organization, element: <OrganizationSettingsPage /> },
  ],
};

export const router = createBrowserRouter([unguardedPublicRoutes, guestRoutes, authenticatedRoutes]);
